import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Todas as Categorias
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Encontre o Que Você
            <br />
            <span className="text-foreground-500">Procura</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 bg-background-50 border border-background-200/60 rounded-xl hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`Hoobuy ${cat.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}